import { ReactElement, useState } from "react";
import "./styles.scss";
import { useMessages } from "../../contexts/messages/context";
import RuletaLogo from "./images/logo_ruleta.png";

const MegapuestaError = (): ReactElement => {
  const { sendMessage } = useMessages();
  const [disabled, setDisabled] = useState(false);

  return (
    <div className={"error-modal"}>
      <div className={"error-body"}>
        <img src={RuletaLogo} className={"roulette-logo"} />
        <h2 className={"title"}>Ooops!</h2>
        <p className={"description"}>Por favor inténtelo de nuevo más tarde.</p>
        <button
          disabled={disabled}
          onClick={() => {
            sendMessage({ type: "REFRESH" });
            setDisabled(true);
          }}
          className={"button"}
        >
          Reintentar
        </button>
      </div>
    </div>
  );
};

export default MegapuestaError;
